/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Plan_OwnInputs */

const en_us2_coaching_plan_own = /** @type {(inputs: Coaching_Plan_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This plan is the person's own. To change it, assign a template or ask the AI: it becomes a draft you approve.`)
};

const pt_br2_coaching_plan_own = /** @type {(inputs: Coaching_Plan_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este plano é da própria pessoa. Para mudar, atribua um modelo ou peça à IA: vira um rascunho que você aprova.`)
};

const pt_pt2_coaching_plan_own = /** @type {(inputs: Coaching_Plan_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este plano é da própria pessoa. Para mudar, atribua um modelo ou peça à IA: vira um rascunho que você aprova.`)
};

/** @type {(inputs: Coaching_Plan_OwnInputs) => LocalizedString} */
const es_419_coaching_plan_own = en_us2_coaching_plan_own;

/** @type {(inputs: Coaching_Plan_OwnInputs) => LocalizedString} */
const fr_fr2_coaching_plan_own = en_us2_coaching_plan_own;

/** @type {(inputs: Coaching_Plan_OwnInputs) => LocalizedString} */
const de_de2_coaching_plan_own = en_us2_coaching_plan_own;

/** @type {(inputs: Coaching_Plan_OwnInputs) => LocalizedString} */
const it_it2_coaching_plan_own = en_us2_coaching_plan_own;

/**
* | output |
* | --- |
* | "This plan is the person's own. To change it, assign a template or ask the AI: it becomes a draft you approve." |
*
* @param {Coaching_Plan_OwnInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_plan_own = /** @type {((inputs?: Coaching_Plan_OwnInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Plan_OwnInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_plan_own(inputs)
	if (locale === "es-419") return es_419_coaching_plan_own(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_plan_own(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_plan_own(inputs)
	if (locale === "de-DE") return de_de2_coaching_plan_own(inputs)
	if (locale === "it-IT") return it_it2_coaching_plan_own(inputs)
	return en_us2_coaching_plan_own(inputs)
});
export { coaching_plan_own as "coaching.plan_own" }